// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"694cb0ec","453":"69c85e64"}[chunkId] + ".chunk.js";
};